export default __webpack_public_path__ + "static/media/work_back_icon.3e0fe517.svg";